import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'rewards.howitworks.new.header',
    description: 'Heading label for How it Works section',
    defaultMessage: 'How it Works',
  },
  subheading: {
    id: 'rewards.howitworks.new.subheading',
    description: 'Subheading label for How it Works section',
    defaultMessage:
      'Joining Starbucks® Rewards means unlocking access to benefits like quick and easy ordering, tasty Rewards and—yes, free coffee.',
  },
  earnStars: {
    id: 'rewards.howitworks.new.cards.earnstars',
    description: 'Card title about earning stars',
    defaultMessage: 'Earn Stars',
  },
  earnStarsDescription: {
    id: 'rewards.howitworks.new.cards.earnstars.body',
    description: 'Card description about earning stars',
    defaultMessage:
      'Receive Stars for every $1 spent, plus earn extra Stars by participating in our challenges, games and more!',
  },
  getRewarded: {
    id: 'rewards.howitworks.new.cards.getrewarded',
    description: 'Card title for redeeming rewards',
    defaultMessage: 'Get Rewarded',
  },
  getRewardedDescription: {
    id: 'rewards.howitworks.new.cards.getrewarded.body',
    description: 'Card description about redeeming rewards',
    defaultMessage:
      'Redeem your Stars for Rewards—like free food, drinks, and more! Start redeeming with as little as 25 Stars!',
  },
  indulgeBenefits: {
    id: 'rewards.howitworks.new.cards.indulgebenefits',
    description: 'Card title about growing benefits',
    defaultMessage: 'Indulge in the Benefits',
  },
  indulgeBenefitsDescription: {
    id: 'rewards.howitworks.new.cards.indulgebenefits.body',
    description: 'Card description about growing benefits',
    defaultMessage:
      'As you earn Stars, you’ll work your way through our tiers, where your benefits will grow as you progress.',
  },
});
